import { GetterTree } from 'vuex';
import { TutorsState } from '@/store/tutors/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<TutorsState, RootState> = {
  /**
   * チューターIDを使ってチューター詳細を取得
   * @param {string} tutorId チューターID
   */
  findTutorById: (state: TutorsState) => (id: string) => _.find(state.tutors, { id }),
};

export default getters;
